"use client"

import { useEffect, useRef, useState } from "react"

const RESET_MS = 1800

export const useCopyFeedback = (idleLabel: string) => {
    const [label, setLabel] = useState(idleLabel)
    const reset = useRef<ReturnType<typeof setTimeout> | null>(null)

    useEffect(() => () => {
        if (reset.current !== null) {
            clearTimeout(reset.current)
        }
    }, [])

    const flash = (next: string) => {
        setLabel(next)

        if (reset.current !== null) {
            clearTimeout(reset.current)
        }

        reset.current = setTimeout(() => setLabel(idleLabel), RESET_MS)
    }

    const copy = (text: string) => {
        if (!navigator.clipboard?.writeText) {
            flash("Copie impossible")

            return
        }

        navigator.clipboard.writeText(text).then(
            () => flash("Copié"),
            () => flash("Copie impossible")
        )
    }

    return { label, copy, flash }
}
